import { ColumnDefinition } from 'components/Grid/types';

import { UserFieldGridRow } from 'utils/api/modules/user/user.types';

export const apiNameForRow = (row: UserFieldGridRow): string =>
  row.kind === 'dropdown' ? row.key : `custom_field_${row.slot}`;

export const fieldTypeForRow = (row: UserFieldGridRow): string => (row.kind === 'dropdown' ? 'Dropdown' : 'Text');

export const basicColumns = [
  { field: 'label', headerName: 'Field label', sortable: false, flex: 1 },
  {
    field: 'apiName',
    headerName: 'API name',
    sortable: false,
    flex: 1,
    valueGetter: (_value: unknown, row: UserFieldGridRow) => apiNameForRow(row),
  },
  {
    field: 'fieldType',
    headerName: 'Field type',
    sortable: false,
    flex: 1,
    valueGetter: (_value: unknown, row: UserFieldGridRow) => fieldTypeForRow(row),
  },
] as unknown as ColumnDefinition[];
